import { createEntityAdapter } from '@reduxjs/toolkit';
import { IValveConnection } from 'application/project/api/Connection';

export const valveConnectionAdapter = createEntityAdapter<IValveConnection, string>({
  selectId: (connection) => connection.valveConnectionKey,
});
